import type { ReactNode } from 'react'
import { ACOLHIMENTO_WHATSAPP_URL } from '@cannect/services/resources/recurrency/constants'
import type { SubscriptionDetail } from '@cannect/services/resources/recurrency/types'
import { subscriptionsCopy } from '../copy'

const copy = subscriptionsCopy.delivery

export const DeliveryPaymentSection = ({
  detail,
  cardAction
}: {
  detail: SubscriptionDetail
  cardAction?: ReactNode
}) => (
  <section
    aria-labelledby="sub-delivery"
    className="flex flex-col gap-4 rounded-xl border border-solid border-neutral-100 bg-white p-4 md:p-6">
    <h2 id="sub-delivery" className="text-lg font-semibold text-neutral-800">
      {subscriptionsCopy.sections.deliveryPayment}
    </h2>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div className="flex flex-col gap-1 text-sm">
        <span className="font-semibold text-neutral-700">{copy.address}</span>
        <span className="text-neutral-800">{detail.address?.label || copy.noAddress}</span>
        <span className="text-neutral-600">
          {copy.addressHelp}.{' '}
          <a
            href={ACOLHIMENTO_WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-primary-700 underline">
            {copy.talkToUs}
          </a>
        </span>
      </div>
      <div className="flex flex-col items-start gap-2 text-sm">
        <span className="font-semibold text-neutral-700">{copy.card}</span>
        <span className="text-neutral-800">
          {detail.card
            ? subscriptionsCopy.cardLabel(detail.card.brand, detail.card.lastDigits)
            : subscriptionsCopy.noCard}
        </span>
        {cardAction}
      </div>
    </div>
  </section>
)
